<template>
    <div class="card-panel hoverable this-month-score-card">
        <h4 class="card-title">Current Month Scores</h4>
        <div class="divider"></div>
        <div class="row">
            <div class="col s12 m12 l12">

                <div v-if="loadByUserId === 0 && isAdmin">Select a member to display.</div>
                <div v-else>
                    <span v-if="loading">Loading ...</span>

                    <div v-if="!hasData && !loading && isAdmin">
                        <h6>There is no current month scores data for this member.</h6>
                    </div>

                    <div class="row" v-show="!loading && hasData && data">
                        <table>
                            <tr>
                                <td valign="center" align="center" class="table-halve score-td">
                                    <!--<div class="score-card col s12 m12 ml12 center">-->
                                        <!--<div class="card-panel hoverable bold-text" v-bind:class="data.caption.class">-->
                                            <!--&lt;!&ndash; score &ndash;&gt;-->
                                            <!--<span class="full-score" v-html="data.full_score"></span>-->

                                            <!--&lt;!&ndash; percentage &ndash;&gt;-->
                                            <!--<div class="card-panel bold-text percentage-card"-->
                                                 <!--v-bind:class="data.percentage.class"-->
                                                 <!--v-html="data.percentage.value"-->
                                            <!--&gt;</div>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                    <div class="col s12 m12 ml12 center">
                                        <!-- score -->
                                        <span class="full-score" v-html="data.full_score"></span>
                                    </div>
                                </td>
                                <td valign="center" align="center" rowspan="2" class="image-td">
                                    <div class="col s12 m12 l12 center">
                                        <img class="responsive-img performance-img" v-bind:src="data.caption.image"/>
                                        <h5 v-html="data.caption.message"></h5>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td valign="center" align="center" class="percentage-td">
                                    <div class="row">
                                        <div class="col s12 center">
                                            Improvement:
                                            <span v-bind:class="data.percentage.class">
                                                <span v-if="data.percentage.class === 'positive'">
                                                    Increased
                                                </span>
                                                <span v-else>
                                                    Decreased
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col s12 center">
                                            <h5 v-bind:class="data.percentage.class"><i class="material-icons">{{ data.percentage.icon }}</i> <span>{{ data.percentage.value }}</span></h5>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div> <!-- ./card content -->
    </div>
</template>

<script>
  export default {
    name: 'ThisMonthScore',

    props: [
      'dataUrl',
      'pdfUrl',
      'haltInitiate',
      'isAdmin',
      'selectedUser'
    ],

    data () {
      return {
        hasData: false,
        loading: true,
        data: {
          full_score : null,
          percentage: {
            class: null,
            icon: null,
            value: null
          },
          caption: {
            class: null,
            message: null,
            image: null
          }
        },
        loadByUserId: 0
      }
    },

    watch: {
      selectedUser () {
        // from dashboard component
        this.loadByUserId = this.selectedUser.id;
        this.load();
      }
    },


    mounted () {

      // window.addEventListener('reload_this_month_score_summary', (payload) => {
      //   this.loadByUserId = payload.detail.user_id;
      //   this.load();
      // });

      if (this.haltInitiate) {
        return;
      }

      this.load();
    },

    methods: {
      deselectUserId () {
        this.loadByUserId = 0;
        this.hasData = false;
      },

      load () {
        this.loading = true;
        this.data = {
            full_score : null,
            percentage: {
                class: null,
                value: null
            },
            caption: {
                class: null,
                message: null,
                image: null
            }
        };
        let data = '?user_id=' + this.loadByUserId;

        axios.post(this.dataUrl + data)
          .then((res) => {
            this.loading = false;

            this.hasData = (res.data.data.full_score > 0);

            this.data = res.data.data;
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
    .this-month-score-card {
        .full-score {
            font-size: 4em;
        }

        .score-card {
            .card-panel {
                padding: 30px;
                color: #FFF;
                position: relative;

                &.over {
                    background-color: #fd7478;
                }
                &.good {
                    background-color: #84d8b8;
                }
                &.low {
                    background-color: #d8b884;
                }

                .full-score {
                    font-size: 4rem;
                }

                .percentage-card {
                    padding: 3px;
                    position: absolute;
                    font-size: 1rem;
                    right: 5%;
                    top: 5%;

                    &.positive {
                        background: #4267b2;
                    }
                    &.negative {
                        background: #e84949;
                    }
                }
            }
        }

        .performance-img {
            height: 15vh;
        }

        table {
            td {
                &.table-halve {
                    width: 50%;
                }

                &.score-td {
                    padding: 0 5px;
                    height: 5vh;
                }

                &.image-td {
                    height: 10vh;
                }

                &.percentage-td {
                    height: 5vh;

                    i {
                        &.material-icons {
                            vertical-align: middle;
                        }
                    }

                    .positive {
                        color: #4267b2;
                    }
                    .negative {
                        color: #e84949;
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/scores/partials/ThisMonthScore.vue